import HHAExchangeLogo from '../assets/icons/hhaexchange-icon.svg';

export interface IntegrationProvider {
  type: string;
  title: string;
  icon: string;
}


export const INTEGRATION_REGISTRY: Record<string, IntegrationProvider> = {
  hhaexchange: {
    type: 'hhaexchange',
    title: 'HHAexchange',
    icon: HHAExchangeLogo,
  },
};


export const getIntegrationConfig = (type: string): IntegrationProvider | null => {
  return INTEGRATION_REGISTRY[type] || null;
};

